import React, { Component } from "react";
import { Space, Button, Row, Col, } from "antd";

import "./ButtonBar.less";

export default class ButtonBar extends Component {

  getActionComp = (item) => {
    if (React.isValidElement(item)) {
      return item;
    }

    const { type = "", visible, } = item;
    if (false === visible) {
      return null;
    }

    if ("cancel" === type) {
      return (
        <Button
          loading={item.loading}
          onClick={item.onClick}
          disabled={item.disabled}
        >
          {item.title || "取消"}
        </Button>
      );
    }

    if ("confirm" === type) {
      return (
        <Button
          type="primary"
          loading={item.loading}
          onClick={item.onClick}
          disabled={item.disabled}
        >
          {item.title || "确认"}
        </Button>
      );
    }

    if (type) {
      return (
        <Button
          onClick={item.onClick}
          disabled={item.disabled}
        >
          {item.title}
        </Button>
      )
    }

    return null;
  };

  render() {
    const { actions = [], } = this.props;
    const style = {
      textAlign: "right",
      ...this.props.style,
    };
    return (
      <Row gutter={16}>
        <Col span={24} style={style}>
          <Space>
            {/* 限制10个按钮数量 */}
            {actions.length > 0 && this.getActionComp(actions[0])}
            {actions.length > 1 && this.getActionComp(actions[1])}
            {actions.length > 2 && this.getActionComp(actions[2])}
            {actions.length > 3 && this.getActionComp(actions[3])}
            {actions.length > 4 && this.getActionComp(actions[4])}
            {actions.length > 5 && this.getActionComp(actions[5])}
            {actions.length > 6 && this.getActionComp(actions[6])}
            {actions.length > 7 && this.getActionComp(actions[7])}
            {actions.length > 8 && this.getActionComp(actions[8])}
            {actions.length > 9 && this.getActionComp(actions[9])}
            {this.props.children}
          </Space>
        </Col>
      </Row>
    );
  };

};
